import SplatModelSagas from './sagas'
import * as splatActions from './actions'
import SplatModelTimeline from './components/SplatModelTimeline'
import splatReducer from './reducers'
import * as splatSelectors from './selectors'

export default SplatModelTimeline

export { splatActions, splatReducer, splatSelectors, SplatModelSagas }
